import React from 'react'
import { Col, Input, Label, Row } from 'reactstrap'
import { putData } from '../../utils/server'

export default function AddImageModal(props: {
  setmodal_backdrop: React.Dispatch<React.SetStateAction<boolean>>
  put_image: Function
}) {
  function handleAddImage(event: any) {
    event.preventDefault()
    const file = event.target.elements.image.files[0]
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
      putData('/image', {
        image: reader.result,
        name: file.name.replace(/\.[^/.]+$/, ''),
        type: 'post',
      }).then(
        (data) => {
          console.log(`response: ${data}`)
          // props.put_image(data)
          props.setmodal_backdrop(false)
        },
        (error) => {
          console.log(error)
        },
      )
    }
  }

  return (
    <div className="m-4">
      <div className="modal-header">
        <h5 className="modal-title" id="staticBackdropLabel">
          Add Image Pack
        </h5>
        <button
          type="button"
          className="btn-close"
          onClick={() => {
            props.setmodal_backdrop(false)
          }}
          aria-label="Close"
        ></button>
      </div>
      <div className="modal-body">
        <form className="form" onSubmit={handleAddImage}>
          <Row className="mb-4">
            <Label htmlFor="title" className="col-sm-3 col-form-label">
              Image:
            </Label>
            <Col sm={9}>
              <Input
                type="file"
                className="form-control"
                id="image"
                name="image"
                required
              />
            </Col>
          </Row>
          <div className="modal-footer">
            <input type="submit" value="Submit" className="btn btn-primary" />
          </div>
        </form>
      </div>
    </div>
  )
}
